import React from "react";
import GoogleMapReact from "google-map-react";
import { GOOGLE_MAPS_APIKEY } from "../../config/Apis";
import { FaLocationPin } from "react-icons/fa6";
import { LocIcon } from "../icons/Icons";

const AnyReactComponent = ({ text }) => <LocIcon size={35} />;

export default function GoogleMap(props) {
  // const defaultProps = {
  //   center: ,
  //   zoom: 11,
  // };
  return (
    // Important! Always set the container height explicitly
    <div
      style={{
        height: "60vh",
        width: "95%",
        marginTop: 10,
        borderRadius: 10,
        overflow: "hidden",
        marginRight: 20,
        marginLeft: 20,
        ...props.style,
      }}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_MAPS_APIKEY, libraries: ["places"] }}
        defaultCenter={{
          lat: props.lat ? Number(props.lat) : 40.7127753,
          lng: props.lng ? Number(props.lng) : -74.0059728,
        }}
        defaultZoom={11}
        center={{
          lat: props.lat ? Number(props.lat) : 40.7127753,
          lng: props.lng ? Number(props.lng) : -74.0059728,
        }}
        yesIWantToUseGoogleMapApiInternals
      >
        <AnyReactComponent
          lat={props.lat ? props.lat : 40.7127753}
          lng={props.lng ? props.lng : -74.0059728}
          text="My Marker"
        />
      </GoogleMapReact>
    </div>
  );
}
